<template>
  <material-card
    :title="$t('components.contributionscontrol.termview.title')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="visibility"
    v-if="term !== null && term !== undefined"
  >
    <v-card-text>
      <v-container fluid>
        <v-row>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.employer") }}
            <br />
            <span class="minfo">
              {{ translate2(employer, "Name") }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.term") }}
            <br />
            <span class="minfo">
              {{ translate2(term, "Name") }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.start_date") }}
            <br />
            <span class="minfo">
              {{ formatDate(term.StartDate) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.end_date") }}
            <br />
            <span class="minfo">
              {{ formatDate(term.EndDate) }}
            </span>
          </div>
        </v-row>
        <v-row>
          <v-col cols="auto" class="align-self-center">
            <v-btn
              :loading="loading"
              dark
              color="success"
              @click="tryGetReport()"
            >
              {{ $t("components.getreports.get") }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-if="showReport" id="report-div">
          <v-divider></v-divider>
          <div style="margin-top:10px">
            <v-flex>
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="success"
                    dark
                    style="margin-right:10px;"
                  >
                    <v-icon>file_download</v-icon>
                    {{ $t("globals.download") }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="downloadExcel()">
                    <v-list-item-title>
                      {{ $t("components.getreports.excel") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadPdf()">
                    <v-list-item-title>
                      {{ $t("components.getreports.pdf") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </div>
          <v-row>
            <v-col sm12>
              <iframe
                :src="pdfFileLink"
                style="height:500px; width: 100%; border: none;"
              ></iframe>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn text :loading="loading" @click="Close">
        {{ $t("globals.close") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import { translate2 } from "../../trans2";
export default {
  components: {
    ErrorHandler,
  },
  props: {
    term: Object,
    employer: Object,
  },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    file: null,
    showReport: false,
    pdfFileLink: null,
  }),
  computed: {
    ...mapGetters("common", {
      settings: "settings",
      selectedPlan: "plan",
    }),
  },
  methods: {
    ...mapActions("transactions", ["getContributionsReport"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async tryGetReport() {
      this.showReport = false;
      this.loading = true;

      try {
        let payload = {
          PlanId: this.selectedPlan.Id,
          TermId: this.term.Id,
          ReportType: "ImportedContributions",
        };
        // this.payload.HasAdminFees = this.planParameters.HasAdminFees;
        // this.payload.HasCommissions = this.planParameters.HasCommissions;
        // this.payload.HasContributions = this.planParameters.HasContributions;
        // this.payload.HasPaymentTracking = this.planParameters.HasPaymentTracking;
        // this.payload.HasRemittances = this.planParameters.HasRemittances;
        // this.payload.TracksMembersActivity = this.planParameters.TracksMembersActivity;
        // this.payload.CoverageGroups = this.selected.CoverageGroups.map(
        //   (scg) => {
        //     return scg.Name;
        //   }
        // );
        // this.payload["ReportType"] = this.selectedReport;
        // this.payload.ReportId = this.reportId;
        this.file = (await this.getContributionsReport({
          payload: payload,
        })).data;
        this.showReport = true;
        this.pdfFileLink = this.settings.APIURL + "pdfs/" + this.file.PDFName;
        setTimeout(() => {
          document.getElementById("report-div").scrollIntoView({
            behavior: "smooth",
          });
        }, 750);
      } catch (error) {
        // error.messageParams = [this.selectedReport];
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("id", "link1");
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
    async downloadPdf() {
      try {
        const response = await this.fetchFile({
          url: this.settings.APIURL + "pdfs/" + this.file.PDFName,
          filename: this.file.PDFName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.PDFName);
      } catch (error) {
        this.error = error;
      }
    },
    async downloadExcel() {
      try {
        var response = await this.fetchFile({
          url: this.settings.APIURL + "excels/" + this.file.ExcelName,
          filename: this.file.ExcelName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.ExcelName);
      } catch (error) {
        this.error = error;
      }
    },
    Close() {
      this.showReport = false;
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.member-view /deep/ .v-list-group__items > .v-list-item {
  padding-left: 45px;
}
.text-white {
  color: white;
}
</style>
